import { SALARY_SLIP } from "../../routes";

export const NOTIFICATION_TEXT = {
    HEADER: "Notifications",
    NO_NOTIFICATIONS: "No notifications",
    MARK_ALL_AS_READ: "Mark all as read",
    FETCH_ERROR: "Failed to fetch notifications.",
    MARK_READ_ERROR: "Failed to mark notifications as read.",
};

export const MESSAGES_TYPE = {
    INFO: "INFO",
    SUCCESS: "SUCCESS",
    WARNING: "WARNING",
    ERROR: "ERROR",
}

export const NOTIFICATIONS_TYPE = {
    ATTENDANCE: "attendance",
    BILL: "bill",
    TASK: "task",
    LEAVE_APPROVAL: "leave_approval",
    LEAVE_REQUEST: "leave_request",
    SALARY_SLIP: "salary_slip",
    EMPLOYEE_DOCUMENT: "employee_document",
    ONBOARDING_DOCUMENT: "onboarding_document",
}

export const MARK_AS_READ="Mark As Read"